import type { IOnboardingStep, ITourEvents } from "@features/onboarding";
import { useStoriesStore } from "@pages/stories/store";
import { CREDITS_ENABLED } from "./constants";

export const PLATFORM_STEPS: IOnboardingStep[] = [
  {
    key: "platform-nav",
    dim: true,
    dimClearSelector: '[data-tour-dim-clear="sidebar"]',
    selector: '[data-tour="platform-nav"]',
    title: "Navigate Storydoc from here",
    description:
      "Jump between your dashboard, stories, analytics, integrations, and automations. Everything's one click away.",
    placement: "right-start",
    arrowStaticOffset: 20,
  },
  {
    key: "libraries",
    dim: true,
    dimClearSelector: '[data-tour-dim-clear="sidebar"]',
    selector: '[data-tour="libraries-nav"]',
    title: "Your reusable building blocks",
    description:
      "Design, media, slides, templates, and variables live here. Set them up once and reuse them across every deck.",
    placement: "right-start",
    arrowStaticOffset: 20,
  },
  {
    key: "analytics-snapshot",
    selector: '[data-tour="dashboard-stats"]',
    title: "A snapshot of the last 30 days",
    description:
      "See how your decks performed at a glance. New links, readers, time spent, and completion rate.",
    placement: "bottom",
    scrollIntoView: true,
  },
  {
    key: "recently-viewed",
    selector: '[data-tour="stories-tab"]',
    title: "Pick up where you left off",
    description: "Find your recent work and the decks you've favorited.",
    placement: "bottom",
    scrollIntoView: true,
  },
  {
    key: "starter-decks",
    selector: '[data-tour="starter-story"]',
    title: "Decks made for you",
    description:
      "Our AI Agent prepared a few decks that pair well with what you're building. Open one to start in seconds.",
    placement: "top-start",
    arrowStaticOffset: 16,
    scrollIntoView: true,
    prepare: () => {
      const stories = useStoriesStore.getState();
      // setType also resets the persisted status filter, so only switch when needed.
      if (stories.type !== "stories") stories.setType("stories");
      if (stories.homeScope !== "all") stories.setHomeScope("all");
    },
  },
  {
    key: "create-more",
    selector: '[data-tour="create-story"]',
    title: "Ready to create more?",
    description:
      "Start from a prompt, a template, existing slides or directly from a blank canvas.",
    placement: "bottom-end",
    scrollIntoView: true,
  },
  {
    key: "all-set",
    selector: '[data-tour="onboarding-card"]',
    title: "You're all set!",
    description: CREDITS_ENABLED
      ? "Finish the quick onboarding checklist to earn AI credits and get the most out of your Storydoc account."
      : "Finish the quick onboarding checklist to get the most out of your Storydoc account.",
    placement: "bottom",
    scrollIntoView: true,
    // GetMostOutCard opens itself for this step without touching the user's saved setting.
  },
];

export const PLATFORM_TOUR_EVENTS: ITourEvents = {
  viewStep: (n) => `view platform walkthrough step ${n}`,
  skip: "platform walkthrough click skip tour",
  next: "platform walkthrough click next step",
  finish: "platform walkthrough finish",
};
